module.exports = __webpack_public_path__ + "i18n/zh-TW.d7bdbf8bb15804fb9550ac6c31e92644.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/zh-TW.json
// module id = 1105
// module chunks = 76